import { type DomainMessages } from 'domains/collections/utils/domain/intl'
import { type CollectionsCollection } from 'domains/collections/api'

export const canCurrentRetailerModifyCollection = (
  collection: Pick<CollectionsCollection, 'requiredRetailerIds'>,
  currentlyScopedRetailerId: string
): boolean => {
  const isClientMode = Boolean(currentlyScopedRetailerId)

  // in client mode (ie: when accessing as a specific retailer), users should only edit collections that are scoped to just that retailer
  // if not in client mode
  return isClientMode
    ? collection.requiredRetailerIds.length === 1 &&
        collection.requiredRetailerIds[0] === currentlyScopedRetailerId
    : true
}

export const collectionStatusMessage = (
  collection: Pick<CollectionsCollection, 'active' | 'activeAdminOnly'>
): DomainMessages => {
  if (collection.active) {
    return 'collectionsDomain.collectionsForm.section.details.status.active'
  } else if (collection.activeAdminOnly) {
    return 'collectionsDomain.collectionsForm.section.details.status.activeAdminOnly'
  }

  return 'collectionsDomain.collectionsForm.section.details.status.inactive'
}
